const shopingCart = {
  namespaced: true,
  state: {
    cart: [],
  },
  actions: {
    addProductToCart(context, product) {
      // Normalise undefined → '' so the comparison always works
      const colorId     = product.color_id           ?? '';
      const attributeId = product.attribute_value_id ?? '';

      const cartItem = context.state.cart.find(item =>
        item.id                === product.id &&
        item.color_id          === colorId     &&
        item.attribute_value_id === attributeId
      );

      if (!cartItem) {
        // New variant → push as fresh cart row
        context.commit('pushProductToCart', { ...product, color_id: colorId, attribute_value_id: attributeId });
      } else {
        // Already in cart → add the selected qty (not just +1)
        context.commit('incrementItemQuantity', { cartItem, qty: product.qty_num || 1 });
      }
    },

    removeCartItem({ commit }, cartItem) {
      commit('removeItemFromCart', cartItem);
    },

    updateItemQuantity({ commit }, { cartItem, quantity }) {
      commit('setItemQuantity', { cartItem, quantity });
    },

    emptyCart({ commit }) {
      commit('emptyCart');
    },
  },
  mutations: {
    pushProductToCart(state, product) {
      state.cart.push({
        id:                  product.id,
        color_id:            product.color_id           ?? '',
        attribute_id:        product.attribute_id       ?? '',
        attribute_value_id:  product.attribute_value_id ?? '',
        quantity:            product.qty_num            || 1,
        details:             product,
      });
    },
    incrementItemQuantity(state, { cartItem, qty = 1 }) {
      const item = state.cart.find(i =>
        i.id                === cartItem.id &&
        i.color_id          === cartItem.color_id &&
        i.attribute_value_id === cartItem.attribute_value_id
      );
      if (item) item.quantity += qty;
    },
    setItemQuantity(state, { cartItem, quantity }) {
      const item = state.cart.find(i =>
        i.id                === cartItem.id &&
        i.color_id          === cartItem.color_id &&
        i.attribute_value_id === cartItem.attribute_value_id
      );
      if (item) item.quantity = quantity;
    },
    removeItemFromCart(state, cartItem) {
      // Match by id + color + attribute so variants are removed independently
      const idx = state.cart.findIndex(i =>
        i.id                === cartItem.id &&
        i.color_id          === cartItem.color_id &&
        i.attribute_value_id === cartItem.attribute_value_id
      );
      if (idx !== -1) state.cart.splice(idx, 1);
    },
    emptyCart(state) {
      state.cart = [];
    },
  },
  getters: {
    cartProducts(state) {
      return state.cart;
    },
    cartTotal(state, getters) {
      return getters.cartProducts.reduce((total, product) => {
        const price    = parseFloat(product.details.price)    || 0;
        const discount = parseFloat(product.details.discount) || 0;
        const finalPrice = discount > 0
          ? price - (price * discount) / 100
          : price;
        return total + finalPrice * product.quantity;
      }, 0).toFixed(2);
    },
  },
};

export default shopingCart;
